var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJiraPriorityArrowMedium(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.25 8.66487C20.25 9.13347 19.9142 9.51334 19.5 9.51334H4.5C4.08579 9.51334 3.75 9.13347 3.75 8.66487C3.75 8.19628 4.08579 7.81641 4.5 7.81641H19.5C19.9142 7.81641 20.25 8.19628 20.25 8.66487Z",
    fill: "#F38C2C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.25 15.3352C20.25 15.8038 19.9141 16.1836 19.4999 16.1836H4.50009C4.08587 16.1836 3.75005 15.8038 3.75 15.3352C3.74995 14.8666 4.0857 14.4867 4.49991 14.4867H19.5001C19.9143 14.4867 20.25 14.8666 20.25 15.3352Z",
    fill: "#F38C2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJiraPriorityArrowMedium);
export default __webpack_public_path__ + "static/media/jira-priority-arrow-medium.7c1ee85928cae18f733a34cc431438a0.svg";
export { ForwardRef as ReactComponent };